// extracted by mini-css-extract-plugin
export default {"disconnect-btn":"styles_disconnect-btn__1Ps6b"};